// extracted by mini-css-extract-plugin
export default {"wrapper":"Menu_wrapper__gC7mF","menuContent":"Menu_menuContent__Hjx1O","open":"Menu_open__Q6dB0"};